import { ICopyChecklistEntregaUseCase } from "../../../presentation/useCases/create/copy_checklist_entrega_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateChecklistEntregaUseCase
 */

export class CopyChecklistEntregaUseCase implements ICopyChecklistEntregaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idChecklistEntrega: number,
    codigo?: string,
    descricao?: string,
    revisao?: string,

  ): Promise<void> {
    return this.repository.copiaChecklistEntrega(
      idChecklistEntrega,
      codigo ?? 'copia-' + String(idChecklistEntrega + 1),
      descricao ?? 'copia-' + String(new Date().getTime()),
      revisao

    );
  }
}
